import React from 'react';
import { useAnalytics } from '../hooks';
import { GenericShareButton, InnerShareButton } from './social-sharing.styles';
import { EmailIcon } from './icons';
import { colorCSS } from '../../styles';
export function EmailShareButton({ block = false, buttonColor = colorCSS('N300'), buttonText = 'Email', buttonTextColor = 'white', iconColor = 'white', message, shareUrl }) {
    const { sendTrackEvent } = useAnalytics();
    const url = encodeURI(`mailto:?subject=Trello&body=${message}\n\n${shareUrl}`);
    return (React.createElement(GenericShareButton, { block: block, buttonColor: buttonColor, colorOverride: buttonTextColor, href: url, title: buttonText, onClick: () => sendTrackEvent('clickedAnchor', {
            event: 'clicked',
            eventComponent: 'EmailShareButton',
            label: buttonText,
            href: url
        }) },
        React.createElement(InnerShareButton, null,
            React.createElement(EmailIcon, { color: iconColor }),
            React.createElement("span", null, buttonText))));
}
//# sourceMappingURL=EmailShareButton.js.map